import { isMicrosoftRing } from '@office-start/config-query-wrapper-service';
export function resolvePeopleCardConfig(_a) {
    var _b, _c, _d;
    var featureSettings = _a.featureSettings, identity = _a.identity;
    var peopleCardSettings = featureSettings.peopleCard;
    // FeatureSettings parsing
    var clientType = (_b = peopleCardSettings === null || peopleCardSettings === void 0 ? void 0 : peopleCardSettings.clientType) !== null && _b !== void 0 ? _b : '';
    var clientContextType = (_c = peopleCardSettings === null || peopleCardSettings === void 0 ? void 0 : peopleCardSettings.clientContextType) !== null && _c !== void 0 ? _c : '';
    var complianceEnvironment = (_d = peopleCardSettings === null || peopleCardSettings === void 0 ? void 0 : peopleCardSettings.complianceEnvironment) !== null && _d !== void 0 ? _d : '';
    // Logic
    var region = getRegion(featureSettings, identity);
    return {
        clientType: clientType,
        clientContextType: clientContextType,
        region: region,
        complianceEnvironment: complianceEnvironment,
    };
}
function getRegion(featureSettings, identity) {
    var _a, _b;
    var region = (_b = (_a = featureSettings.peopleCard) === null || _a === void 0 ? void 0 : _a.region) !== null && _b !== void 0 ? _b : '';
    if (region === '' && isMicrosoftRing(featureSettings, identity)) {
        region = 'msit';
    }
    return region;
}
//# sourceMappingURL=resolvePeopleCardConfig.js.map